import { useState } from 'react';
import { GridDetailRowProps } from "@progress/kendo-react-grid";
import { TabStrip, TabStripTab, TabStripSelectEventArguments } from '@progress/kendo-react-layout';
import LoadBoardBid from './Bid';
import LoadBoardVehicles from './Vehicles';
import LoadBoardAllianceVehicles from './AllianceVehicles';
import LoadBoardNetworkVehicles from './NetworkVehicles';
import LoadBoardDecline from './Decline';
import LoadBoardMap from './Map';
import LoadBoardCombinedRateAnalysis from './CombinedRateAnalysis';
import LoadBoardPayRateAnalysis from './PayRateAnalysis';
import LoadBoardCustomerRateAnalysis from './CustomerRateAnalysis';

const LoadBoardDetailRow = (props: GridDetailRowProps) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const dataItem = props.dataItem;
  const tabProps = { shipmentId: dataItem.ShipmentID };

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelectedIndex(e.selected);
  };

  return (
    <TabStrip selected={selectedIndex} onSelect={handleSelect} animation={false}>
      <TabStripTab title="Bid">
        <LoadBoardBid {...tabProps} />
      </TabStripTab>
      <TabStripTab title="Vehicles">
        <LoadBoardVehicles shipmentId={dataItem.ShipmentID} />
      </TabStripTab>
      <TabStripTab title="Sylectus">
        <LoadBoardAllianceVehicles shipmentId={dataItem.ShipmentID} />
      </TabStripTab>
      <TabStripTab title="Full Circle">
        <LoadBoardNetworkVehicles shipmentId={dataItem.ShipmentID} />
      </TabStripTab>
      <TabStripTab title="Decline">
        <LoadBoardDecline shipmentId={dataItem.ShipmentID} />
      </TabStripTab>
      <TabStripTab title="Map">
        <LoadBoardMap shipmentId={dataItem.ShipmentID} />
      </TabStripTab>
      <TabStripTab title="Revenue and Pay">
        <LoadBoardCombinedRateAnalysis shipmentId={dataItem.ShipmentID} />
      </TabStripTab>
      <TabStripTab title="Pay Rates">
        <LoadBoardPayRateAnalysis shipmentId={dataItem.ShipmentID} />
      </TabStripTab>
      <TabStripTab title="Customer Rates">
        <LoadBoardCustomerRateAnalysis shipmentId={dataItem.ShipmentID} />
      </TabStripTab>
    </TabStrip>
  );
};

export default LoadBoardDetailRow;
